import axios, { AxiosError } from 'axios'
import config from 'config'

import { OctaneLogger } from '../../integrations/datadog/OctaneLogger'

export interface ResponseClientApplication {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    vehicles_matrix: any
}

export default async function getVehiclesMatrix(
    clientApplicationId: number,
    abortController?: AbortController | null,
) {
    try {
        if (!clientApplicationId) {
            throw new Error(
                'Invalid clientApplicationId used with getVehiclesMatrix',
            )
        }

        const { data }: { data: ResponseClientApplication } = await axios.get(
            // eslint-disable-next-line max-len
            `${config.API_BASE_URL}/api/v1/client_applications/${clientApplicationId}/`,
            {
                signal: abortController?.signal,
                withCredentials: true,
                params: {
                    include_vehicles: true,
                },
            },
        )

        return data
    } catch (error) {
        OctaneLogger.axiosError(
            `Error getting vehicles matrix for clientApplicationId ${clientApplicationId}:`,
            error as AxiosError,
            {
                applicationId: clientApplicationId,
            },
        )

        throw error
    }
}
